import '../assets/NcEllipsisedOption-B6gjXSS9.css';
import { N as i, F as r } from "../chunks/index-CnpswYi6.mjs";
import { n as a } from "../chunks/_plugin-vue2_normalizer-Bj5bLKV4.mjs";
const n = {
  name: "NcEllipsisedOption",
  components: {
    NcHighlight: i
  },
  props: {
    name: {
      type: String,
      default: ""
    },
    search: {
      type: String,
      default: ""
    }
  },
  computed: {
    needsTruncate() {
      return this.name && this.name.length >= 10;
    },
    /**
     * Index at which to split the name if it is longer than 10 characters.
     *
     * @return {number} The position at which to split
     */
    split() {
      return this.name.length - Math.min(Math.floor(this.name.length / 2), 10);
    },
    part1() {
      return this.needsTruncate ? this.name.slice(0, this.split) : this.name;
    },
    part2() {
      return this.needsTruncate ? this.name.slice(this.split) : "";
    },
    /**
     * The ranges to highlight. Since we split the string for ellipsising,
     * the Highlight component cannot figure this out itself and needs the ranges provided.
     *
     * @return {Array} The array with the ranges to highlight
     */
    highlight1() {
      return this.search ? r(this.name, this.search) : [];
    },
    /**
     * We shift the ranges for the second part by the position of the split.
     * Ranges out of the string length are discarded by the Highlight component,
     * so we don't need to take care of this here.
     *
     * @return {Array} The array with the ranges to highlight
     */
    highlight2() {
      return this.highlight1.map((s) => ({
        start: s.start - this.split,
        end: s.end - this.split
      }));
    }
  }
};
var h = function() {
  var t = this, e = t._self._c;
  return e("span", { staticClass: "name-parts", attrs: { title: t.name } }, [e("NcHighlight", { staticClass: "name-parts__first", attrs: { text: t.part1, search: t.search, highlight: t.highlight1 } }), t.part2 ? e("NcHighlight", { staticClass: "name-parts__last", attrs: { text: t.part2, search: t.search, highlight: t.highlight2 } }) : t._e()], 1);
}, l = [], c = /* @__PURE__ */ a(
  n,
  h,
  l,
  !1,
  null,
  "08c4259e",
  null,
  null
);
const g = c.exports;
export {
  g as default
};
